module.exports = __webpack_public_path__ + "static/media/Facebook.47919627.svg";